'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var errors_formatError = require('./errors/formatError.js');
require('whatwg-fetch');
var errors_appError = require('./errors/appError.js');
var networkProfiling = require('./networkProfiling.js');
var errors_formatAISError = require('./errors/formatAISError.js');
require('./tslib.es6-f8b34207.js');
require('./errors/errorCodes.js');
require('./eventEmitter.js');
require('lodash');
require('./device.js');
require('ua-parser-js');
require('./errors/AISErrorCodes.js');

function doFetch(url, options) {
    var response;
    var origResp;
    var jsonResponse;
    var hasQuery = url.indexOf('?') !== -1;
    if ((options === null || options === void 0 ? void 0 : options.query) && typeof options.query === 'object') {
        for (var key in options.query) {
            url += "".concat(hasQuery ? '&' : '?').concat(encodeURIComponent(key), "=").concat(encodeURIComponent(options.query[key]));
            hasQuery = true;
        }
    }
    return fetch(url, options)
        .then(function (res) {
        if (networkProfiling.NetworkProfiling.isInstantiate()) {
            origResp = res.clone();
        }
        response = res;
        if (options === null || options === void 0 ? void 0 : options.rawResponse) {
            return response;
        }
        if (options === null || options === void 0 ? void 0 : options.type) {
            switch (options.type) {
                case 'arrayBuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'formData':
                    return response.formData();
                case 'json':
                    return response.json();
                case 'text':
                default:
                    return response.text();
            }
        }
        return response.json();
    })
        .then(function (parsedData) {
        if (!(options === null || options === void 0 ? void 0 : options.rawResponse)) {
            if (parsedData) {
                jsonResponse = parsedData;
            }
            if (parsedData === null || parsedData === void 0 ? void 0 : parsedData.error) {
                throw new Error(parsedData.error);
            }
        }
        return parsedData;
    })
        .catch(function (error) {
        if (!(error instanceof errors_appError.AppError)) {
            if ((options === null || options === void 0 ? void 0 : options.errorFormatter) === 'AIS') {
                throw errors_formatAISError.formatAISError(error, response || {});
            }
            else {
                throw errors_formatError.formatError(jsonResponse || error, true, response || {});
            }
        }
        else {
            throw error;
        }
    }).finally(function () {
        if (networkProfiling.NetworkProfiling.isInstantiate() && origResp) {
            networkProfiling.NetworkProfiling.instance().handleResponse(origResp);
        }
    });
}

exports.doFetch = doFetch;
